import axios from "axios";
import { useState, useContext } from "react";
import { Context } from "./Context";
import { editingTypes } from './config.json';

export default function NewJob(props) {
  const [skuCount, setSkuCount] = useState();
  const [imageCount, setImageCount] = useState();
  const [editingType, setEditingType] = useState("");
  const context = useContext(Context);

  function createNewJob(event) {
    event.preventDefault();
    let newJob = {
      sku_count: skuCount,
      image_count: imageCount,
      editing_type: editingType,
      editor_id: context.editor,
      project_id: context.project.id,
      project_location: context.project.location
    };

    axios({
      method: "post",
      url:
        process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX +
        "/api/v1/editor-tracker-form/add-new-job",
      data: { newJob },
    })
      .then((resp) =>
        resp.status === 200 ?
            getJobStatus(newJob, resp?.data)
          : null
      )
      .catch((err) => alert("server error!!!"));
  }

  function handleChange(event) {
    let valueToSet = event.target.value;
    if (event.target.id === "skuCount") setSkuCount(valueToSet);
    else if (event.target.id === "imageCount") setImageCount(valueToSet);
    else setEditingType(valueToSet);
  }

  let types = editingTypes.map((types) => (
    <option value={types}>{types}</option>
  ));

  function getJobStatus (newJob, newJobId) {
    axios({
      method: "get",
      url: process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX + "/api/v1/operations/get-ongoing-jobs?editor_id=" + props.editorIdForJobStatus,
    })
      .then((res) => 
        res.status === 200 ?
          (context.setCurrDayJobs((jobs) => {
            jobs.push({
              ...newJob,
              job_start: res?.data?.jobs.length ? res.data.jobs[res.data.jobs.length - 1]?.job_start : '1997-01-01T5:38:34.000Z',
              job_id: newJobId, // new job id
              project_name: context?.project.name,
              project_location: context?.project.location,
              entp_name: context?.enterprise.name,
              status: 'started'
            });
            return jobs;
          }),
          context.setToShow("project-selector")) : null
      )
  }


  return (
    <>
      {context.toShow === "new-job" ? (
        <div className="new-job">
          <h4>{"New Job Details"}</h4>
          <form onSubmit={createNewJob}>
            <div className="form-inputs">
              <input
                type="number"
                id="skuCount"
                placeholder="SKU Count"
                value={skuCount}
                onChange={handleChange}
                required
              />
              <input
                type="number"
                id="imageCount"
                placeholder="Image Count"
                value={imageCount}
                onChange={handleChange}
                required
              />
              <select
                id="editingType"
                value={editingType}
                onChange={handleChange}
                required
              >
                {types}
              </select>
            </div>
            <div className="form-buttons">
              <button type="submit">Start Job</button>
              <button
                class="cancel-button"
                onClick={() => context.setToShow("project-selector")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      ) : null}
    </>
  );
}
